/**
 * Registriert den Service Worker der App (ein Worker im Wurzelbereich, ADR-0027): App-Shell, Benachrichtigungen.
 *
 * Neue Versionen (Bericht N11): Der Worker aktiviert sich sofort (`skipWaiting`, `clientsClaim` in `sw.ts`), die laufende
 * Seite behält aber ihr altes Bündel. Eine Home-Bildschirm-App auf dem iPhone wird beim Zurückholen nicht neu geladen und
 * sucht dabei von sich aus nicht nach einer neuen Version. Deshalb sucht die App bei jedem Sichtbarwerden nach einem Update
 * und lädt neu, sobald ein neuer Worker die Seite übernommen hat – sofort, wenn sie gerade gestartet oder zurückgeholt wurde
 * und niemand etwas eingibt, sonst beim nächsten Wechsel in den Hintergrund. So unterbricht ein Update nie eine Eingabe.
 */
const FRISCH_MS = 10_000;

export async function serviceWorkerRegistrieren(): Promise<ServiceWorkerRegistration | null> {
  if (!("serviceWorker" in navigator) || import.meta.env.DEV) return null;
  try {
    const registrierung = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
    aufNeueVersionenAchten(registrierung);
    return registrierung;
  } catch {
    return null;
  }
}

function aufNeueVersionenAchten(registrierung: ServiceWorkerRegistration): void {
  // Erstinstallation: der Worker übernimmt eine Seite ohne Worker – das ist keine neue Version
  let hatteWorker = !!navigator.serviceWorker.controller;
  let sichtbarSeit = Date.now();
  let neuLaden = false;

  const eingabeLaeuft = () => {
    const aktiv = document.activeElement;
    return !!aktiv?.matches("input, textarea, [contenteditable='true']") || !!document.querySelector("[role='dialog'], [role='alertdialog']");
  };
  const jetztNeuLaden = () => { neuLaden = false; window.location.reload(); };

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hatteWorker) { hatteWorker = true; return; }
    neuLaden = true;
    if (document.visibilityState === "hidden" || (Date.now() - sichtbarSeit < FRISCH_MS && !eingabeLaeuft())) jetztNeuLaden();
  });

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      if (neuLaden) jetztNeuLaden();
      return;
    }
    sichtbarSeit = Date.now();
    void registrierung.update().catch(() => undefined);
  });
}
